(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Loop through all forms containing the address fields
    document.querySelectorAll('form').forEach(function (form) {
      // Handle country select elements within the form
      form.querySelectorAll('select[data-address-country-select]').forEach(function (countrySelect) {
        // Get the default country value from the data-default attribute
        const defaultCountry = countrySelect.getAttribute('data-default');

        if (defaultCountry) {
          // Find the option that matches the data-default either by value or text
          const matchingOption = Array.from(countrySelect.options).find(
            (option) => option.value === defaultCountry || option.text.trim() === defaultCountry,
          );

          if (matchingOption) {
            // Set the selected option
            countrySelect.value = matchingOption.value;

            // Trigger a change event to load provinces if necessary
            const changeEvent = new Event('change');
            countrySelect.dispatchEvent(changeEvent);
          }
        }
      });

      // Handle provinces loading if there's any dynamic province select logic
      form.querySelectorAll('select[name="address[province]"]').forEach(function (provinceSelect) {
        const defaultProvince = provinceSelect.getAttribute('data-default');

        if (defaultProvince) {
          // Find the option that matches the data-default either by value or text
          const matchingOption = Array.from(provinceSelect.options).find(
            (option) => option.value === defaultProvince || option.text.trim() === defaultProvince,
          );

          if (matchingOption) {
            // Set the selected province
            provinceSelect.value = matchingOption.value;
          }
        }
      });

      // Handle default address checkbox
      const defaultAddressCheckbox = form.querySelector('input[name="address[default]"]');
      if (defaultAddressCheckbox) {
        const isDefault = defaultAddressCheckbox.getAttribute('data-default') === 'true';
        defaultAddressCheckbox.checked = isDefault;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asl-geur-van-de-maand"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-asl-monthly-scent]';

  const initialize = (scope) => {
    const sections = [];
    if (scope.matches && scope.matches(selector)) sections.push(scope);
    if (scope.querySelectorAll) sections.push(...scope.querySelectorAll(selector));

    sections.forEach((section) => {
      if (section.dataset.countdownInitialized === 'true') return;
      section.dataset.countdownInitialized = 'true';

      const end = Date.parse(section.dataset.countdownEnd);
      const clock = section.querySelector('[data-countdown-clock]');
      const expired = section.querySelector('[data-countdown-expired]');
      const originalPrices = Array.from(section.querySelectorAll('[data-countdown-original]'));
      const salePrices = Array.from(section.querySelectorAll('[data-countdown-sale]'));
      const regularPrices = Array.from(section.querySelectorAll('[data-countdown-regular]'));

      const finish = () => {
        clock.hidden = true;
        expired.hidden = false;
        originalPrices.forEach((price) => { price.hidden = true; });
        salePrices.forEach((price) => { price.hidden = true; });
        regularPrices.forEach((price) => { price.hidden = false; });
      };

      if (!Number.isFinite(end) || end <= Date.now()) {
        finish();
        return;
      }

      const update = () => {
        const remaining = Math.max(0, end - Date.now());
        if (remaining === 0) {
          finish();
          window.clearInterval(section._aslCountdownInterval);
          return;
        }

        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        section.querySelector('[data-countdown-days]').textContent = String(days).padStart(2, '0');
        section.querySelector('[data-countdown-hours]').textContent = String(hours).padStart(2, '0');
        section.querySelector('[data-countdown-minutes]').textContent = String(minutes).padStart(2, '0');
        section.querySelector('[data-countdown-seconds]').textContent = String(seconds).padStart(2, '0');
        clock.hidden = false;
      };

      update();
      section._aslCountdownInterval = window.setInterval(update, 1000);
    });
  };

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target._aslCountdownInterval) {
      window.clearInterval(event.target._aslCountdownInterval);
    }
  });

  initialize(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asl-geurquiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-asl-scent-quiz]';
  const recommendations = {
    fresh: ['aqua-bloom-geurolie', 'bamboo-verde-geurolie', 'crimson-orange-geurolie'],
    floral: ['art-of-love-geurolie', 'ivory-essence-geurolie', 'opal-glow-geurolie'],
    woody: ['black-vetiver-cafe-geurolie', 'sandalwood-citrus-geurolie', 'hazelwood-geurolie'],
    sweet: ['velvet-fig-geurolie', 'sugar-blush-geurolie', 'frosted-vanilla-geurolie'],
    amber: ['golden-vice-geurolie', 'velvet-fig-geurolie', 'black-vetiver-cafe-geurolie']
  };
  const profiles = {
    hotel: { name: 'The Hotel Lover', copy: 'Je houdt van een verfijnde, gastvrije sfeer.' },
    cozy: { name: 'The Cozy Escape', copy: 'Je zoekt warmte en comfort in huis.' },
    fresh: { name: 'The Fresh Soul', copy: 'Je wordt blij van een frisse, heldere sfeer.' },
    romantic: { name: 'The Romantic', copy: 'Je kiest voor een zachte en persoonlijke sfeer.' },
    signature: { name: 'The Signature Collector', copy: 'Je houdt van karaktervolle, bijzondere geuren.' }
  };
  const familyCopy = {
    fresh: 'frisse en groene geuren',
    floral: 'bloemige en zachte geuren',
    woody: 'warme, houtachtige geuren',
    sweet: 'zoete en romige geuren',
    amber: 'warme amber- en kruidige geuren'
  };
  const intensityCopy = {
    subtiel: 'een subtiele',
    'in balans': 'een gebalanceerde',
    aanwezig: 'een duidelijke'
  };

  const initialize = (root) => {
    if (!root || root.dataset.quizInitialized === 'true') return;
    root.dataset.quizInitialized = 'true';

    const form = root.querySelector('[data-quiz-form]');
    const toggleButton = root.querySelector('[data-quiz-toggle]');
    const panel = root.querySelector('.asl-scent-quiz__panel');
    if (!form || !toggleButton || !panel) return;

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let mobileExpanded = false;
    const syncPanelVisibility = () => {
      const isMobile = mobileQuery.matches;
      panel.hidden = isMobile && !mobileExpanded;
      toggleButton.setAttribute('aria-expanded', String(!isMobile || mobileExpanded));
    };

    toggleButton.addEventListener('click', () => {
      if (!mobileQuery.matches) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mobileExpanded = !mobileExpanded;
      syncPanelVisibility();
      if (mobileExpanded) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    mobileQuery.addEventListener('change', syncPanelVisibility);
    syncPanelVisibility();

    const steps = Array.from(form.querySelectorAll('[data-quiz-step]'));
    const next = root.querySelector('[data-quiz-next]');
    const back = root.querySelector('[data-quiz-back]');
    const error = root.querySelector('[data-quiz-error]');
    const formControls = root.querySelector('[data-quiz-controls]');
    const results = root.querySelector('[data-quiz-results]');
    const progressLabel = root.querySelector('[data-quiz-step-label]');
    const progress = root.querySelector('[data-quiz-progress]');
    const resultName = root.querySelector('[data-quiz-profile-name]');
    const resultCopy = root.querySelector('[data-quiz-result-copy]');
    const resultProducts = root.querySelector('[data-quiz-recommendations]');
    let currentStep = 1;

    const showStep = () => {
      steps.forEach((step) => {
        step.hidden = Number(step.dataset.quizStep) !== currentStep;
      });
      progressLabel.textContent = 'Vraag ' + currentStep + ' van ' + steps.length;
      progress.style.width = ((currentStep / steps.length) * 100) + '%';
      back.hidden = currentStep === 1;
      next.textContent = currentStep === steps.length ? 'Toon mijn geuren' : 'Volgende';
      error.hidden = true;
    };

    const showResults = () => {
      const answers = steps.map((step) => {
        const selected = step.querySelector('input[type="radio"]:checked');
        return selected ? selected.value : '';
      });
      const [mood, family, room, intensity] = answers;
      const profile = profiles[mood];
      const handles = recommendations[family] || [];

      if (!profile || handles.length === 0 || !room || !intensity) {
        error.hidden = false;
        return;
      }

      resultName.textContent = profile.name;
      resultCopy.textContent = profile.copy + ' Je voorkeur gaat uit naar ' + familyCopy[family] + ', voor je ' + room + ', met ' + intensityCopy[intensity] + ' geurbeleving.';
      resultProducts.innerHTML = '';

      const templates = root.querySelectorAll('template[data-quiz-product-template]');
      handles.slice(0, 3).forEach((handle) => {
        const template = Array.from(templates).find((item) => item.dataset.quizProductTemplate === handle);
        if (template) resultProducts.append(template.content.cloneNode(true));
      });

      form.hidden = true;
      formControls.hidden = true;
      root.querySelector('[data-quiz-progress-wrap]').hidden = true;
      results.hidden = false;
      results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    next.addEventListener('click', () => {
      const selectedAnswer = steps[currentStep - 1]?.querySelector('input[type="radio"]:checked');
      if (!selectedAnswer) {
        error.hidden = false;
        return;
      }

      if (currentStep === steps.length) {
        showResults();
        return;
      }

      currentStep += 1;
      showStep();
    });

    back.addEventListener('click', () => {
      if (currentStep > 1) {
        currentStep -= 1;
        showStep();
      }
    });

    form.addEventListener('change', () => {
      error.hidden = true;
    });

    root.querySelector('[data-quiz-restart]').addEventListener('click', () => {
      form.reset();
      currentStep = 1;
      form.hidden = false;
      formControls.hidden = false;
      root.querySelector('[data-quiz-progress-wrap]').hidden = false;
      results.hidden = true;
      resultProducts.innerHTML = '';
      showStep();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    showStep();
  };

  const initializeWithin = (scope) => {
    if (scope.matches && scope.matches(selector)) initialize(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(initialize);
  };

  initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const isEditor = !!(window.Shopify && Shopify.designMode);

    const debounce = (fn, delay = 250) => {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    };

    const getSection = () => document.querySelector('#product-recommendations');

    const fetchRecommendations = async (targetNode) => {
      try {
        if (!targetNode) targetNode = getSection();
        if (!targetNode) return;

        var skeletonEl = targetNode.closest('[id^="shopify-section-"]');
        var skel = skeletonEl ? skeletonEl.querySelector('.pr-skeleton') : null;

        const url = targetNode.dataset.url;
        if (!url) return console.warn('[PR] Missing data-url');

        const res = await fetch(url, { cache: 'no-store' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const html = await res.text();

        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newContent = temp.querySelector('.product-recommendations');
        if (!newContent) return;

        if (newContent.querySelector('.swiper-slide')) {
          targetNode.innerHTML = newContent.innerHTML;
          if (skel) skel.style.display = 'none';
          console.info('[PR] Updated');
        } else {
          if (skel) skel.style.display = '';
          const mainSection = document.querySelector('.product-recommendations');
          mainSection.style.display = 'none';
          console.info('[PR] No products — showing skeleton');
          return;
        }

        setTimeout(() => {
          if (typeof initializeMuskPRODUCTRECOMMENDATION === 'function') {
            initializeMuskPRODUCTRECOMMENDATION();
            console.info('[PR] init re-run');
          }
        }, 150);
      } catch (err) {
        console.error('[PR] fetchRecommendations error:', err);
        var skeletonEl = targetNode ? targetNode.closest('[id^="shopify-section-"]') : null;
        var skel = skeletonEl ? skeletonEl.querySelector('.pr-skeleton') : null;
        if (skel) skel.style.display = '';
      }
    };

    const initObserver = () => {
      const section = getSection();
      if (!section) return;

      if ('IntersectionObserver' in window && !isEditor) {
        const observer = new IntersectionObserver(
          (entries, obs) => {
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
              obs.unobserve(entry.target);
              fetchRecommendations(entry.target);
            }
          },
          { rootMargin: '0px 0px 200px 0px' },
        );
        observer.observe(section);
      } else {
        fetchRecommendations(section);
      }
    };

    const setupEditorListeners = () => {
      const safeReload = debounce(() => {
        const section = getSection();
        if (section) fetchRecommendations(section);
        else console.info('[PR] No section found — waiting...');
      }, 500);

      const events = [
        'shopify:section:load',
        'shopify:section:select',
        'shopify:block:select',
        'shopify:section:reorder',
        'shopify:section:deselect',
        'shopify:inspector:save',
      ];

      events.forEach((e) => {
        document.addEventListener(e, safeReload);
      });

      // Recheck every few seconds if section appears (for page switch in editor)
      if (isEditor) {
        setInterval(() => {
          const section = getSection();
          if (section && !section.dataset.initialized) {
            section.dataset.initialized = 'true';
            console.info('[PR] Section detected after save — reinit');
            initObserver();
          }
        }, 2000);
      }
    };

    const init = () => {
      const section = getSection();
      if (!section) {
        console.info('[PR] No product recommendations section found');
        if (isEditor) setupEditorListeners(); // ensure listeners still bind
        return;
      }
      initObserver();
      if (isEditor) setupEditorListeners();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
